import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a3e06aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "content-title" }, "Histórico Paciente", -1))
const _hoisted_3 = { class: "patient-history scrolled" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "detail-appointment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (app) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass({
          'patient-appointment': true,
          'current-appointment': app.id == _ctx.appointment_id,
        }),
          key: app.id,
          onClick: ($event: any) => (_ctx.updateAppointmentRecord(app))
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.showAppointmentDateTime(
            app.scheduled_day,
            app.start_time,
            app.end_time
          )), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(app.professional_name), 1),
            _createElementVNode("span", null, _toDisplayString(app.specialty_description), 1)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}